import { RootDispatch } from "@store";
import { allDevices, getDevices } from "@utils/dev_utils";
import {
  ActionBaseMinerTypes,
  ActionSetMinerTypes,
  ActionTypesMinerTypesE,
} from "./actionTypes";
import { batch } from "react-redux";

export function setAllMinerTypes(types: string[]): ActionSetMinerTypes {
  return {
    type: ActionTypesMinerTypesE.SET_ALL_MINER_TYPES,
    payload: {
      miner_types: types,
    },
  };
}

export function setMinerTypes(types: string[]): ActionSetMinerTypes {
  return {
    type: ActionTypesMinerTypesE.SET_MINER_TYPES,
    payload: {
      miner_types: types,
    },
  };
}

export function clearMinerTypes(): ActionBaseMinerTypes {
  return {
    type: ActionTypesMinerTypesE.CLEAR_MINER_TYPES,
  };
}

export function getAllTypes(miner_types: string[]) {
  return async (dispatch: RootDispatch) => {
    let devices: any[] = miner_types;
    batch(async () => {
      dispatch(setMinerTypes(devices));
      if (!getDevices(true).length) {
        const allDev = await allDevices();
        devices = deleteCopies([
          ...devices,
          ...allDev.map((item) => item.name),
        ]);
        dispatch(setAllMinerTypes(devices));
        return;
      }
      dispatch(
        setAllMinerTypes(deleteCopies([...devices, ...getDevices(true)]))
      );
    });
  };
}

const deleteCopies = (types: string[]): string[] => {
  return types
    .map((t) => {
      return t.toLowerCase().replace(/\s+/g, " ");
    })
    .filter((t, i, arr) => arr.indexOf(t) === i);
};
